// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__32nKf","productName":"Table_productName__d8IzA"};